
import { Statistics } from './Statistics';
/** Do not store stats in the memory. Stats are not needed on daily basis */
export class EmptyStatistics extends Statistics {
    /** @inheritDoc */
    incrementCriterionFunctionFullCacheUsed() {
        // do nothing
    }
    /** @inheritDoc */
    incrementCriterionFunctionPartialCacheUsed() {
        // do nothing
    }
    /** @inheritDoc */
    start(_name) {
        // do nothing
    }
    /** @inheritDoc */
    end(_name) {
        // do nothing
    }
}
